import { createContext } from 'react'

export const HeaderContext = createContext({})
export const HeaderProvider = HeaderContext.Provider
